/** Hidden Input **/

.checkboxField_input {
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  cursor: pointer;
  height: 24px;
  outline: none;
  position: relative;
  width: 24px;
  z-index: 1;
}

.checkboxField_input:disabled {
  cursor: default;
}

.checkboxField_input:indeterminate,
.checkboxField_input:checked {
  background-color: transparent;
}

.checkboxField_input:focus-visible::after {
  border: 1px solid var(--colors-primary-main);
  bottom: -3px;
  background-color: transparent;
  content: '';
  border-radius: 7px;
  display: inherit;
  left: -3px;
  position: absolute;
  right: -3px;
  top: -3px;
}

/** Presentational Checkbox **/

.checkboxField_input ~ div[role='presentation'] {
  --checked-icon: ''; /* Required to pass stylelint check */
  --indeterminate-icon: ''; /* Required to pass stylelint check */

  border-radius: 4px;
  height: 24px;
  position: absolute;
  top: 0;
  width: 24px;
  background-color: var(--colors-grays-white);
  border: 2px solid var(--colors-grays-mid);
  box-shadow: var(--shadows-inner);
}

.checkboxField_input ~ div[role='presentation']::after {
  content: '';
  display: block;
  height: 100%;
  position: absolute;
  top: 0;
  width: 100%;
}

.checkboxField_input:checked ~ div[role='presentation']::after,
.checkboxField_input:indeterminate ~ div[role='presentation']::after {
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 4px;
  filter: brightness(100);
}

.checkboxField_input:checked ~ div[role='presentation']::after {
  background-image: var(--checked-icon);
}

.checkboxField_input:indeterminate ~ div[role='presentation']::after {
  background-image: var(--indeterminate-icon);
}

.checkboxField_input:checked ~ div[role='presentation'],
.checkboxField_input:indeterminate ~ div[role='presentation'] {
  border: none;
  box-shadow: none;
  background-color: var(--colors-primary-main);
}
